import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import RemiseFilter from "../../../../Components/Remises/RemiseV2/RemiseFilter";
import { societeId } from "../../../../_App/Redux/Slices/Auth/authSlice";
import { useAppDispatch, useAppSelector } from "../../../../_App/Redux/hooks";
import {
  currentpage,
  findArticlesFiltresApi,
  ListArticles,
  totalPages,
} from "../../../../_App/Redux/Slices/article/articleSlice";
import RemiseList from "../../../../Components/Remises/RemiseV2/RemiseList";
import PaginationLayout from "../../../../_Layouts/Pagination/PaginationLayout";
import { datafilterType } from "../../../../_App/Types/Entites/ArticleFilter";
import {
  allOrganisationsApi,
  ListOrganisations,
} from "../../../../_App/Redux/Slices/organisations/organisationSlice";

export default function RemiseV2Page(
{  remise_id,
  setListCondition
  }:any
) {
  const societe = useAppSelector(societeId);
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const [selectedOrg, setselectedOrg] = useState([]);

  const current_page = useAppSelector(currentpage);
  const totalpages = useAppSelector(totalPages);
  const [index, setindex] = useState(!current_page ? 1 : current_page);
  const articles = useAppSelector(ListArticles);
  const [ListArticle, setListArticle] = useState<any[]>([]);
  const [selections, setSelections] = useState<any>({});
  const listOrganisation = useAppSelector(ListOrganisations);
  const [Filtre, setFiltre] = useState<datafilterType>();
  const optionsOrganisation: any = listOrganisation.map((item: any) => ({
    value: item._id.toString(),
    label: item.nom,
  }));
  const totalItem = (totalpages || 0) * (Filtre?.NLigne || 100);
  useEffect(() => {
    if (societe) {
      setFiltre((prev: any) => ({
        ...prev,
        societe: societe,
        NLigne: 100,
      }));
      dispatch(allOrganisationsApi(societe));
    }
  }, [societe]);

  useEffect(() => {
    setListArticle(articles);
  }, [articles]);
  useEffect(() => {
    const carateristiqueOptions: any[] = [];

    for (const key in selections) {
      if (Array.isArray(selections[key])) {
        selections[key].forEach((obj: any) => {
          carateristiqueOptions.push(obj.value);
        });
      }
    }
    const copie = { ...Filtre };
    copie.index = index;
    copie.type = "fils";
    copie.carateristique = carateristiqueOptions;
    copie.societe = societe;
    setFiltre(copie);
    const copiefiltre = {
      ...copie,
      Organisation: selectedOrg.map((org: any) => org.value),
    };

    dispatch(findArticlesFiltresApi(copiefiltre));
  }, [index]);
  const searchfiltre = () => {
    const carateristiqueOptions: any[] = [];

    for (const key in selections) {
      if (Array.isArray(selections[key])) {
        selections[key].forEach((obj: any) => {
          carateristiqueOptions.push(obj.value);
        });
      }
    }
    const copie = { ...Filtre };
    copie.index = 1;
    copie.type = "fils";
    copie.carateristique = carateristiqueOptions;
    copie.societe = societe;

    setFiltre(copie);
    const copiefiltre = {
      ...copie,
      Organisation: selectedOrg.map((org: any) => org.value),
    };
    dispatch(findArticlesFiltresApi(copiefiltre));
  };
  return (
    <div>
      <RemiseFilter
        t={t}
        societeid={societe}
        setFiltre={setFiltre}
        Filtre={Filtre}
        searchfiltre={searchfiltre}
        selections={selections}
        setSelections={setSelections}
      />
      <RemiseList
        t={t}
        articles={articles}
        ListArticle={ListArticle}
        setListArticle={setListArticle}
        listOrganisation={optionsOrganisation}
        societe_id={societe}
        totalItem={totalItem}
        Filtre={Filtre}
        selectedOrg={selectedOrg}
        setselectedOrg={setselectedOrg}
        remise_id={remise_id}
        setListCondition={setListCondition}
        
      />
      <div className="row layout-spacing">
        <PaginationLayout
          index={index}
          nbrpage={current_page}
          totalpages={totalpages}
          setindex={setindex}
        />
      </div>
    </div>
  );
}
